export default __webpack_public_path__ + "static/media/Build8.41549af5.jpg";